module.exports = "/_next/static/images/7f0b07691d6d886963bfcbf52a6decc9-gift-illustration@1x.png.webp";